import React from 'react';

const ResetButton = () => {
  const handleReset = () => {
    // Resetear todos los inputs de tipo número
    const inputs = document.querySelectorAll('input[type="number"]');
    
    inputs.forEach(input => {
      // Limpiar el valor
      input.value = '';
      
      // Forzar actualización del estado React
      const changeEvent = new Event('change', { bubbles: true });
      input.dispatchEvent(changeEvent);
      
      // Forzar actualización del input
      const inputEvent = new Event('input', { bubbles: true });
      input.dispatchEvent(inputEvent);
    });

    // Recargar la página para asegurar un reseteo completo
    window.location.reload();
  };

  return (
    <div style={{ textAlign: 'center', margin: '1rem' }}>
      <button 
        className="reset-button" 
        onClick={handleReset}
      >
        Limpiar Datos y Comenzar de Nuevo
      </button>
    </div>
  );
};

export default ResetButton;

